export const GET_ALERT_DETAILS = 'GET_ALERT_DETAILS';
export const getAlertDetails = (alertId) => ({
  type: GET_ALERT_DETAILS,
  alertId,
});

export const GET_ALERT_DETAILS_SUCCESS = 'GET_ALERT_DETAILS_SUCCESS';
export const getAlertDetailsSuccess = (alertDetails) => ({
  type: GET_ALERT_DETAILS_SUCCESS,
  alertDetails,
});

export const GET_ALERT_DETAILS_FAILURE = 'GET_ALERT_DETAILS_FAILURE';
export const getAlertDetailsFailure = (e) => ({
  type: GET_ALERT_DETAILS_FAILURE,
  e,
});

export const SHIP_ORDERS_TOGETHER_FROM_ALERT_DETAILS = 'SHIP_ORDERS_TOGETHER_FROM_ALERT_DETAILS';
export const shipOrdersTogether = () => ({
  type: SHIP_ORDERS_TOGETHER_FROM_ALERT_DETAILS,
});
